import React, { useEffect, useRef } from "react";

import LandingPageBody from "../../views/LandingPage/NewHome/MainHome";

import { Box } from "@mui/material";

import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const HomePage = () => {
  const ref = useRef(null);
  const Location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.scrollY === 0) {
        window.scrollTo(0, 0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    if (Location?.state === "ABClick") {
      return ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>BXI: The Lead Bartering Partner of India for Businesses</title>
        <meta property="og:title" content="BXI: The Lead Bartering Partner of India for Businesses" />
        <meta
          name="og:description"
          content="Looking for a B2B marketplace? BXI’s barter exchange helps businesses grow by using the barter system to trade goods and services without cash transactions."
        />
        <meta
          name="description"
          content="Looking for a B2B marketplace? BXI’s barter exchange helps businesses grow by using the barter system to trade goods and services without cash transactions."
        />
         <meta
          name="keywords"
          content=" Barter exchange, barter system, bxi, barter exchange, b2b, marketplace, barter, b2b marketplace"
        />
      </Helmet>

      <>
        <Box
          sx={{
            marginTop: "64px",
          }}
        >
          <LandingPageBody />
        </Box>
      </>
    </Box>
  );
};

export default HomePage;
